/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TableMetadataDto } from '../../models/table-metadata-dto';

export interface DatasourcesDataSourceIdTablesGet$Plain$Params {
  dataSourceId: string;
}

export function datasourcesDataSourceIdTablesGet$Plain(http: HttpClient, rootUrl: string, params: DatasourcesDataSourceIdTablesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TableMetadataDto>>> {
  const rb = new RequestBuilder(rootUrl, datasourcesDataSourceIdTablesGet$Plain.PATH, 'get');
  if (params) {
    rb.path('dataSourceId', params.dataSourceId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TableMetadataDto>>;
    })
  );
}

datasourcesDataSourceIdTablesGet$Plain.PATH = '/datasources/{dataSourceId}/tables';
